import { getLayout } from "components/Layout";
import asyncVoidHandler from "utils/asyncVoidHandler";
import { useRouteParam } from "utils/routeParamHooks";
import BrandEmailInbox from "components/Core/EmailInbox";
import BrandEmailInboxSelected from "components/Core/EmailInbox/Selected";
import HeadTitle from "components/Shared/HeadTitle";

export default function BrandEmailInboxPage() {
  const [emailId, onEmailIdChange] = useRouteParam("selectedEmailId");

  return (
    <>
      <HeadTitle title="Email Inbox" />

      <BrandEmailInbox
        selected={emailId}
        onSelectedChange={asyncVoidHandler(onEmailIdChange)}
      />

      {emailId && <BrandEmailInboxSelected emailId={emailId} />}
    </>
  );
}

BrandEmailInboxPage.getLayout = getLayout;
